export const NULL_STRING = 'null';

export type NullString = typeof NULL_STRING;
